import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

interface StaticPageLayoutProps {
  children: React.ReactNode;
}

export default function StaticPageLayout({ children }: StaticPageLayoutProps) {
  return (
    <div className="min-h-screen bg-[#111] text-white overflow-hidden">
      <PublicHeader />
      {children}
      <PublicFooter />
    </div>
  );
}
